/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_CompletedInputs */



/**
* | output |
* | --- |
* | "Auto format completed" |
*
* @param {Auto_Format_CompletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_completed = /** @type {((inputs?: Auto_Format_CompletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_CompletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Auto-formatage terminé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierung abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione automatica completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование завершено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato automático completado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動フォーマットが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो फॉर्मेट पूरा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática concluída")
	return /** @type {LocalizedString} */ ("Auto format completed")
});